import { equals } from "ramda";

import { RootState } from "src/app/model/store";
import { BlogType } from "src/shared/config";

export const selectBlogs = (state: RootState) => {
  return state.blogs.blogs;
};

export const selectNewBlog = (state: RootState) => {
  return state.blogs.newBlog;
};

export const selectBlogByID = (state: RootState, id: BlogType["id"]) => {
  return state.blogs.blogs.find((blog) => equals(blog.id, id));
};

export const selectSortedBlogsByTags = (
  state: RootState,
  tags: BlogType["tags"],
  id: BlogType["id"],
) => {
  const blogs = state.blogs.blogs;
  const filteredBlogs = blogs.filter((blog) => blog.id !== id);

  return filteredBlogs
    .map((blog) => {
      return {
        ...blog,
        matchCount: blog.tags.filter((tag) => tags.includes(tag)).length,
      };
    })
    .sort((a, b) => {
      return b.matchCount - a.matchCount;
    })
    .slice(0, 3);
};
